var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36008 6.57499C6.28982 6.63361 6.1945 6.66658 6.09508 6.66665L5.90508 6.66665C5.80587 6.66569 5.71094 6.63286 5.64008 6.57499L3.07509 4.43332C3.02776 4.3942 3.00114 4.34095 3.00114 4.2854C3.00114 4.22985 3.02776 4.17661 3.07509 4.13749L3.43009 3.84165C3.47617 3.80246 3.53924 3.78037 3.60509 3.78037C3.67093 3.78037 3.734 3.80246 3.78009 3.84165L6.00008 5.69582L8.22008 3.84165C8.26702 3.80221 8.33092 3.78003 8.39758 3.78003C8.46423 3.78003 8.52813 3.80221 8.57507 3.84165L8.92507 4.13749C8.9724 4.17661 8.99902 4.22985 8.99902 4.2854C8.99902 4.34095 8.9724 4.3942 8.92507 4.43332L6.36008 6.57499Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesc);
export default __webpack_public_path__ + "static/media/Desc.56c19ab7.svg";
export { ForwardRef as ReactComponent };